import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  endpoint = `${environment.api}/menus`;

  constructor(private http: HttpClient) {}
  getMenu(): Observable<any> {
    return this.http.get<any>(`${this.endpoint}`);
  }
}
